/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type GetEventAttendeesForUsersQueryVariables = Types.Exact<{
  user_ids: Array<Types.Scalars["Int"]> | Types.Scalars["Int"];
  event_id: Types.Scalars["Int"];
}>;

export type GetEventAttendeesForUsersQuery = {
  eventAttendees: Array<Pick<Types.EventAttendee, "id" | "user_id" | "has_id">>;
};

export const GetEventAttendeesForUsersDocument = gql`
  query GetEventAttendeesForUsers($user_ids: [Int!]!, $event_id: Int!) {
    eventAttendees(
      where: {
        user_id: { in: $user_ids }
        event_id: { equals: $event_id }
        role: { equals: "hacker" }
      }
    ) {
      id
      user_id
      has_id
    }
  }
`;

/**
 * __useGetEventAttendeesForUsersQuery__
 *
 * To run a query within a React component, call `useGetEventAttendeesForUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventAttendeesForUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventAttendeesForUsersQuery({
 *   variables: {
 *      user_ids: // value for 'user_ids'
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useGetEventAttendeesForUsersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetEventAttendeesForUsersQuery,
    GetEventAttendeesForUsersQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetEventAttendeesForUsersQuery,
    GetEventAttendeesForUsersQueryVariables
  >(GetEventAttendeesForUsersDocument, baseOptions);
}
export function useGetEventAttendeesForUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetEventAttendeesForUsersQuery,
    GetEventAttendeesForUsersQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetEventAttendeesForUsersQuery,
    GetEventAttendeesForUsersQueryVariables
  >(GetEventAttendeesForUsersDocument, baseOptions);
}
export type GetEventAttendeesForUsersQueryHookResult = ReturnType<
  typeof useGetEventAttendeesForUsersQuery
>;
export type GetEventAttendeesForUsersLazyQueryHookResult = ReturnType<
  typeof useGetEventAttendeesForUsersLazyQuery
>;
export type GetEventAttendeesForUsersQueryResult =
  ApolloReactCommon.QueryResult<
    GetEventAttendeesForUsersQuery,
    GetEventAttendeesForUsersQueryVariables
  >;
